import React from "react";
import LayoutProvider from "../../../providers/LayoutProvider";
import "./style.scss"
import Chart from 'react-apexcharts';
import 'apexcharts';
import { getAdminChart, getAdminStats } from "../../../components/Axios/Axios";
import AdminPagesProvider from "../../../providers/AdminPagesProvider";
function AdminDashboard() {
  const [monthlyFlightsData, setMonthlyFlightsData] = React.useState([]);
  const [chartOptions, setChartOptions] = React.useState({
    chart: {
      id: 'bar-chart',
      toolbar: {
        show: true,
      },

      dataLabels: {
        enabled: false,
      },

    },
    colors: ['#00af80'],

    dataLabels: {
      enabled: false,
    },

    plotOptions: {
      bar: {
        columnWidth: 40,
      },
    },

  });

  // const [chartSeries, setChartSeries] = React.useState([
  //   {
  //     name: 'Flights',
  //     data: [440, 550, 410, 640, 220, 450, 348, 780, 320, 900, 210, 1000],
  //   },
  // ]);

  const [usersCount, setUsersCount] = React.useState("");
  const [flightsCount, setFlightsCount] = React.useState("");
  const [aircraftsCount, setAircraftsCount] = React.useState("");
  const [airportsCount, setAirportsCount] = React.useState("");
  const [groupsCount,setGroupsCount]=React.useState("")
  const [activeUsers,setActiveUsers]=React.useState("")
  const [superUsers,setSuperUsers]=React.useState("")
  const fetchStats = async () => {

    try {
      const data = await getAdminStats();
      const data2 =await getAdminChart();
      setMonthlyFlightsData(data2.data)
      setUsersCount(data.totalUsers)
      setFlightsCount(data.totalFlight)
      setAircraftsCount(data.totalAircraft)
      setAirportsCount(data.totalAirport)
      setGroupsCount(data.totalGroup)
      setActiveUsers(data.totalActiveUser)
      setSuperUsers(data.totalSuperUser)
    }
    catch (error) {
      console.error("Error adding flight", error);
    }

  }

  React.useEffect(() => {
    fetchStats();
  }, []);


  return (
    <AdminPagesProvider>
      <LayoutProvider>
        <h6 className="dashboard_subheading">Dashboard {">"} Home</h6>
        <section
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h4 className="dashboard_heading">Dashboard</h4>
        </section>
        <section className="dash_count_section_admin">
          <div className="dash_count_admin">
            <div style={{ display: "flex" }}>
              <h4>Users</h4>
            </div>
            <h3 className="dash_numb">{usersCount}</h3>
          </div>
          <div className="dash_count_admin">
            <div style={{ display: "flex" }}>
              <h4>Super users</h4>
            </div>
            <h3 className="dash_numb">{superUsers}</h3>
          </div>
          <div className="dash_count_admin">
            <div style={{ display: "flex" }}>
              <h4>Active users</h4>
            </div>
            <h3 className="dash_numb">{activeUsers}</h3>
          </div>
          <div className="dash_count_admin">
            <div style={{ display: "flex" }}>
              <h4>Groups</h4>
            </div>
            <h3 className="dash_numb">{groupsCount}</h3>
          </div>
          <div className="dash_count_admin">
            <div style={{ display: "flex" }}>
              <h4>Airports</h4>
            </div>
            <h3 className="dash_numb">{airportsCount}</h3>
          </div>
          <div className="dash_count_admin">
            <div style={{ display: "flex" }}>
              <h4>Flights</h4>
            </div>
            <h3 className="dash_numb">{flightsCount}</h3>
          </div>
          <div className="dash_count_admin">
            <div style={{ display: "flex" }}>
              <h4>Aircrafts</h4>
            </div>
            <h3 className="dash_numb">{aircraftsCount}</h3>
          </div>
        </section>
        <div className="dash_count_admin" style={{ marginTop: "2%" }}>
          <h4 className="heading2">Monthly Flight Progress</h4>
          <Chart
                    options={{
                        ...chartOptions,
                        xaxis: {
                            categories: Object.keys(monthlyFlightsData),
                        },
                    }}
                    series={[
                        {
                            name: 'Flights',
                            data: Object.values(monthlyFlightsData),
                        },
                    ]}
                    type="bar"
                    height={300}
                />
        </div>
      </LayoutProvider>
    </AdminPagesProvider>
  );
}

export default AdminDashboard;
